export default "__VITE_ASSET__Ch6NryP6__"